import { Component } from '@angular/core';
import { LogisticsService } from '../../../../services/logistics.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { StudyReportLogisticsInfo } from '../../../../model/logistics/study-report';

@Component({
  selector: 'app-tool-study-report-transit-control',
  templateUrl: './tool-study-report-transit-control.component.html',
})
export class ToolStudyReportTransitControlComponent {

  items: StudyReportLogisticsInfo[] = [];
  form: FormGroup;
  loading: boolean;
  isSubmited = false;

  constructor(private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , private logisticsService: LogisticsService) {
    this.form = this.formBuilder.group({
      protocol: ['', Validators.required],
    });
  }

  get f() { return this.form.controls; }

  async findStudyReportLogisticsInfo() {
    try {
      if (this.form.valid) {
        this.isSubmited = true;
        this.loading = true;
        this.items = await this.logisticsService
          .getStudyReportLogisticsInfo(this.form.value.protocol);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Estado informe tránsito');
    } finally {
      this.loading = false;
    }
  }
}
